export const locale = {
    lang: 'en',
    data: {
        'TITLE': {
            'Header': 'Tools And Ladders',
        },
        'FIELDS': {
            'ProjectsCoworkerRate': 'Projects Coworker Rate',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save': 'Save',
        }
    }
};